export const MAX_DISPLAYED_INSIGHT = 99;

export const INSIGHT_STATES = {
  NEW: 'NEW',
  DISMISSED: 'DISMISSED',
  ACTIONED: 'ACTIONED',
};

export const INSIGHT_RATINGS = {
  HELPFUL: 1,
  UNHELPFUL: -1,
  NEUTRAL: 0,
};

export const INSIGHT_TYPES = {
  SIMILAR_INCIDENT: 'SIMILAR_INCIDENT',
  SUGGESTED_RESOLVER: 'SUGGESTED_RESOLVER',
};

// PROMPTED => action from insight window
// MANUAL => action from outside of insight window
export const INSIGHT_ACTION_FROM = {
  PROMPTED: 'PROMPTED',
  MANUAL: 'MANUAL',
};

// Insight.incidentInsightReasonType
export const RESOLVER_INSIGHT_TYPES = {
  IMPACTED_SERVICE_OWNER: 'IMPACTED_SERVICE_OWNER',
  LINKED_INCIDENT_ENGAGED: 'LINKED_INCIDENT_ENGAGED',
  SIMILAR_INCIDENT_RESOLVER: 'SIMILAR_INCIDENT_RESOLVER',
};

/** Incident Insight Popups */
export const POPUP_UPDATE_CYCLE = 5_000; // 5 Seconds
export const POPUP_RATE_LIMIT = 5 * 60 * 1_000; // 5 Minutes
